import dayjs from "dayjs";
export const forMataTimer = (timer)=>{
  if(!timer){
    return ''
  }
  return dayjs(timer).format('YYYY-MM-DD HH:mm:ss')
}